module.exports = __webpack_public_path__ + "static/bg02-bde3f86f2b773485ea395c3579dd8bcb.jpg";